import { LoadingSpinner } from '@/components/ui/loading-spinner';
import type { ReactElement } from 'react';

export default function RootLoading(): ReactElement {
  return (
    <div className="flex h-screen w-screen items-center justify-center gap-2 bg-white">
      <LoadingSpinner />
      <h1>Загрузка...</h1>
    </div>
  );
}
